import { WorkflowPhase } from './workflow.enums.js'

/** The two facts about a status the withdrawal rule reads. */
export interface PhasedStatus {
	phase: WorkflowPhase | string
	position: number
}

/**
 * Whether moving from `current` to `target` takes an order back out of the
 * review it was just handed into: `current` is a validation status, `target`
 * is not, and no other validation status sits between them.
 *
 * That last clause is what makes it a withdrawal rather than a rejection. An
 * order that has already passed one review (internal) and sits in the next
 * (external) steps back over a review someone else approved, so that move stays
 * the reviewer's. Read off configured phase and position rather than status
 * codes, so an administrator renaming or adding a lane keeps the rule intact.
 */
export function isWithdrawal(current: PhasedStatus, target: PhasedStatus, statuses: readonly PhasedStatus[]): boolean {
	if (current.phase !== WorkflowPhase.VALIDATION || target.phase === WorkflowPhase.VALIDATION) return false
	if (target.position >= current.position) return false
	return !statuses.some(
		(s) => s.phase === WorkflowPhase.VALIDATION && s.position > target.position && s.position < current.position,
	)
}
